import { SERVER_URL } from "./config";

const groupNames = ["group-1", "group-2"];

const paymentTypeGroupInfo = {
  "group-1": [
    {
      label: "Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "name",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/payment_type/",
      apiConfigKey: "getPaymentTypeSuggestions",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "payment_type_id",
      suggestionKeywordExtra: "desc",
      backendOnClickName: "description",
      keyboardNavigationMap: {
        Enter: "description",
      },
      toValidate: "true",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        name: "name",
        desc: "description",
        id: "payment_type_id",
      },
      idClearanceNeeded: "payment_type_id",
      onChangeIgnoreClearance: ["description"],
    },
  ],
  "group-2": [
    {
      description: "",
      label: "Description",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "description",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/payment_type/",
      suggestionKeyword: "name",
      backendOnClickName: "description",
      keyboardNavigationMap: {
        Enter: "save_button",
      },
      toValidate: "true",
    },
  ],
};

const paymentTypeDataObject = {
  name: "",
  description: "",
};

function paymentTypeValidate(values) {
  let errors = {};

  function validator(value, regexp) {
    var regex = new RegExp(regexp);
    if (values.hasOwnProperty(value)) {
      if (!values[value].trim()) {
        errors[value] = "Required Field";
      } else if (!regex.test(values[value])) {
        errors[value] = "Validation Error";
      } else {
        errors[value] = "";
      }
    }
  }
  for (let group_name of groupNames) {
    for (let i = 0; i < paymentTypeGroupInfo[group_name].length; i++) {
      let field_object = paymentTypeGroupInfo[group_name][i];
      if (field_object.toValidate) {
        validator(field_object.name, field_object.regExpValidation);
      }
    }
  }
  return errors;
}

export { paymentTypeGroupInfo, paymentTypeDataObject, paymentTypeValidate };
